export const getEmbedUrl = (url: string): string | null => {
  try {
    const urlObject = new URL(url);
    const hostname = urlObject.hostname;
    const pathname = urlObject.pathname;

    if (hostname.includes('youtube.com') || hostname.includes('youtu.be')) {
      const videoId =
        hostname.includes('youtu.be') ?
        pathname.substring(1) :
        urlObject.searchParams.get('v');
      return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
    }

    if (hostname.includes('spotify.com')) {
      const parts = pathname.split('/');
      const type = parts[1];
      const id = parts[2];
      if (type && id) {
        return `https://open.spotify.com/embed/${type}/${id}`;
      }
    }

    if (hostname.includes('music.apple.com')) {
      return `https://embed.music.apple.com${pathname}`;
    }

    return null;
  } catch (error) {
    console.error('Invalid URL:', error);
    return null;
  }
};
